import type { IconSvgObject } from './types';

const FileEuroIcon: IconSvgObject = [
  ["path", { d: "M3 9.00146H8C9.10457 9.00146 10 8.10603 10 7.00146V2.00146", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.5 22.0015H5C3.89543 22.0015 3 21.1061 3 20.0015V9.81667C3 9.28553 3.21128 8.7762 3.58724 8.40101L9.41585 2.58434C9.7908 2.21015 10.2989 2 10.8286 2H18C19.1046 2 20 2.89543 20 4V10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 15.5C20.5 14.5 19.6936 14 18.6056 14C17.1665 14 16 15.1665 16 16.6056V19.3944C16 20.8335 17.1665 22 18.6056 22C19.6936 22 20.5 21.5 21 20.5M15 18H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileEuroIcon;
